import { apiClient } from './client';
export const hubspotApi = {
    /** Get OAuth authorization URL to open in popup */
    initiate: () => apiClient.get('/api/Auth/HubSpot/Initiate'),
    /** Check HubSpot connection status for a company */
    getStatus: (clientCompanyId) => apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Integrations/HubSpot/Status`),
    /** Disconnect HubSpot for a company */
    disconnect: (clientCompanyId) => apiClient.post(`/api/ClientCompanies/${clientCompanyId}/Integrations/HubSpot/Disconnect`, {}),
    /** Get HubSpot mapping configuration (or defaults if none saved) */
    getConfig: (clientCompanyId) => apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Integrations/HubSpot/Config`),
    /** Save HubSpot mapping configuration */
    saveConfig: (clientCompanyId, config) => apiClient.put(`/api/ClientCompanies/${clientCompanyId}/Integrations/HubSpot/Config`, config),
    /** Get available HubSpot contact properties (for field mapper dropdown) */
    getProperties: (clientCompanyId) => apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Integrations/HubSpot/Properties`),
    /** Get deal attribution analytics */
    getDealAnalytics: (clientCompanyId) => apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Integrations/HubSpot/DealAnalytics`),
    /** Upload Named Account domains */
    uploadNamedAccounts: (clientCompanyId, domains) => apiClient.post(`/api/ClientCompanies/${clientCompanyId}/Integrations/HubSpot/NamedAccounts`, { domains }),
};
